import {useTheme} from '@mui/material/styles';
import { green, red } from "@mui/material/colors";

export const BoardActionsStyles = () => {
  const theme = useTheme();

  return {
    '& .board-actions': {
      '&__board-menu': {
        alignItems: 'center',
        '& span': {
          marginLeft: '5px',
        },
        '& .board-menu__filters': {
          paddingTop: {
            xs: "6px",
            md: "12px"
          },
          paddingBottom: {
            xs: "6px",
            md: "12px"
          },
          paddingRight: {
            xs: "12px",
            md: "22px"
          },
        },
        '& span button': {
          minWidth: "auto",
          padding: {
            xs: "6px",
            md: "12px"
          },
        }
      },
      '&__board-name, &__board-version': {
        alignItems: 'center',
      },
      '&__board-name form, &__board-version form': {
        alignItems: "center"
      }
    },
    '& .board__edit-actions button': {
      margin:"0 0 4px 4px",
      width: "100%",
    },
    '& .board-name': {
      background: `${theme.palette.primary.light}0D`,
      borderRadius: "4px",
      fontWeight: "bold",
      padding: "14px 12px",
      position: "relative",

      '&__label': {
        position: "absolute",
        top: "-6px",
        fontSize: "12px",
        lineHeight: "12px",
        fontWeight: "normal",
        color: "rgba(0, 0, 0, 0.6)",
      }
    },
    '& .button-edit': {
      textAlign: "center",
    },
    '& .edit-name, & .edit-version': {
      minWidth: "auto",
      padding: "14px",
    }
  }
}

export const BoardGroupCounter = () => {
  const theme = useTheme();

  return {
    '& .group-counter': {
      '&__wrapper': {
        '& > div': {
          fontSize: {
            xs: "12px",
            md: "1.2rem"
          },
          fontWeight: "bold",
          textAlign: "center",
        }
      },
      '&__versus': {
        color: `${theme.palette.primary.main}A6`,
      },
      '&__result': {
        color: theme.palette.primary.main,
      }
    }
  }
}



export const DataFiltersStyles = () => {
  const theme = useTheme();

  return {
    '&.district-filters': {
      alignItems: "center",
      display: "flex",
      flexDirection: {
        xs: "column",
        lg: "row",
      },
    },
    '&.district-filters--hidden .group-counter__wrapper': {
      flexBasis: "auto",
      width: "100%",
    },
    '&.district-filters--hidden .data-filters__collapse-button': {
      position: {
        md: "absolute"
      },
    },
    '&.existing-board .basic-filters': {
      margin: {
        xs: "0 0 12px",
        md: "0 12px 12px",
      },
    },
    '& .basic-filters': {
      alignItems: "center",
      margin: {
        md: "0 12px",
        lg: 0,
      },
      justifyContent: {
        xs: "center",
        md: "unset",
      },
      width: "auto !important",
    },
    '& .sharedFilters': {
      alignItems: "center",
      justifyContent: {
        xs: "center",
        md: "inherit"
      },
    },
    '& .basic-filters span button, & .sharedFilters span button': {
      marginLeft: "4px",
      minWidth: "inherit",
      padding: "8px",
    },
    '& .existingBoard__name': {
      color: theme.palette.primary.main,
      fontWeight: "bold",
      textAlign: "center",
      padding: '16px 10px',
      margin: {
        sm: "10px 0",
        md: 0
      }
    },
    '& .group-counter__wrapper': {
      alignItems: "center",
      background: "none",
      color: theme.palette.primary.main,
      display: "flex",
      flexDirection: "column",
      flexBasis: {
        md: "100%",
      },
      fontWeight: "bold",
      fontSize: "18px",
      flexGrow: 1,
      justifyContent: "center",
      marginBottom: 0,
      minHeight: {
        sm: "74px",
        lg: "auto"
      },
      width: {
        lg: "100%"
      }
    },
    '& .group-counter__versus':{
      marginBottom: "4px",
      opacity: .7,
      textAlign: "center",
    },
    '& .group-counter__result': {
      color: theme.palette.primary.main,
      fontWeight: "bold",
      textAlign: "center",
    },
    "& .custom-groups .group-counter": {
      padding: {
        sm: "30px",
        lg: "0"
      },
      fontWeight: "bold",
      textAlign: "center"
    },
    "& .custom-groups .map-chart": {
      position: "relative"
    },
    '& .editButtonItem button': {
      minWidth: "70px",
    },
    '& .editButtonItem button:last-child': {
      marginTop: "4px",
    },
    '& .button-filters.active': {
      backgroundColor: theme.palette.primary.main,
    },
    '& button-filters svg': {
      marginLeft: "-8px",
      marginRight: "4px",
    },
    "& .editButtonItem": {
      margin: "0px 10px 10px 10px"
    },
      "& .MuiChip-label": {
        backgroundColor: "#808080",
        color: "#ffffff"
    }
  }
}

// This styles fix the problem whe box shadow is
export const ContentTopStyles = {
  marginBottom: "16px",
  '& div[class*="section__wrapper"]:nth-of-type(2n+1)': {
    marginBottom: "3px",
    marginRight: {
      md: "3px",
    },
  },
  "& .section--student-demographics, .section--pupil-spending": {
    background: "#ffffff",
  },
  "& .section--enrollment-brackets, .section--academic-performance": {
    backgroundColor: "#ffffff",
    paddingTop: "10px"
  },
  "& .section--student-demographics, .section--enrollment-brackets": {
    gridColumn: {
      md: "1 / 4",
    }
  },
  "&.section--pupil-spending, .section--academic-performance": {
    gridColumn: {
      md: "4 / 7"
    }
  },
  "& .extra-data": {
    background: "url('../../../IB_Simbol_DB_RGB.png') no-repeat 96% -18px #221349",
    backgroundSize: "68px",
    color: "#ffffff",
    padding: "10px",
    textAlign: "center",
  },
  '& .chart-title': {
    fontWeight: "bold",
    paddingTop: "8px",
    textAlign: "center",
  }
}
export const ContentBottomStyles = {
  "& .section--comparison-cards": {
    listStyleType: 'none',
    padding: 0,
  },
  "& .comparison-card__item > div": {
    height: '100%',
    position: 'relative',
  }
}

// Styles for menu
export const MenuBoxStyles =() => {
 const theme = useTheme();

 return {
   '& > .MuiPaper-root': {
     left:"91px",
     borderRadius: "6px",
     marginTop: "-8px",
     minWidth: "180px",
     backgroundColor: theme.palette.primary.main,
     color: 'white',
     '& .MuiMenu-list': {
       //padding: '4px 0 14px',
     },
     "fieldset": {
       borderColor: "white",
     },

     " input, label, svg": {
       color: "white",
     }
   }
 }
}

// Edit board name/version Input field.
export const InputEditStyles = () => {
  const theme = useTheme();

  return {
    '& .MuiInputBase-root, MuiOutlinedInput-input': {
      color: '#black',
    },

    '& .MuiInputLabel-root': {
      color: '#black',
      top: '0px',
    },

    '& label.Mui-focused': {
      color: '#black',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: theme.palette.primary.light,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#black',
      },
      '&:hover fieldset': {
        borderColor: '#black',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'black',
      },
    },
  }
}

export const SnackbarStyles = () => {
  return {
    "& .custom-groups__save-message p": {
      marginBottom: 0
    },

    "&.custom-groups__save-message .success": {
      color: `${green[500]}`
    },

    "& .custom-groups__save-message .error strong": {
      color: `${red[500]}`
    }
  }
}
